
import { User } from "@/models/user";
import Vue from "vue";
import AppUserInfo from "../UserInfo.vue";
export default Vue.extend({
	data() {
		return {
			user: new User(),
			password: ""
		};
	},
	props: {
		value: {
			type: Object as () => User,
			required: true
		},
	},
	computed: {
		title():string {
			if(this.value.username) {
				return "Show user info:"+this.value.username;
			}
			return "Show user info";
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(val:User) {
				this.user = val;
			}
		}
	},
	methods: {
		cancel() {
			this.$emit("close");
		},
		//custom esc Button event
		escButtonEvent(ev:KeyboardEvent){
			if (ev.key === "Escape") {
				this.cancel();
			}
			return;
		}
	},
	mounted() {
		window.addEventListener("keyup",this.escButtonEvent);
	},
	beforeDestroy(){
		window.removeEventListener("keyup", this.escButtonEvent);
	},
	components: {
		AppUserInfo
	}
});
